import React, { useState } from 'react';
import { FormControl, FormControlLabel, Checkbox } from '@material-ui/core';
import { hasOrgPermission, genericErrorToast } from '@app/helpers';
import { ManageAccount } from '@app/store/constants';
import { useTypedTranslation } from '@app/hooks';
import { useSelector } from 'react-redux';
import { IGlobalState } from '@app/models';
import { usersService } from '@app/services';
import { useParams } from 'react-router';
import { PasslyCheckbox } from "@app/components";

interface IProps {
    checked: Function;
}

export const JitToggle = (props: IProps) => {
    const { translation } = useTypedTranslation();
    const { checked: triggerCheck } = props;
    const { id: userID } = useParams<{ id: string }>();

    const supportsImpersonation: boolean = useSelector((state: IGlobalState) => state.users.user.SupportsImpersonation);

    const [checked, isChecked] = useState<boolean>(supportsImpersonation);

    const handleCheck = (checked: boolean) => {
        const handleSuccess = () => {};

        isChecked(checked);
        triggerCheck(checked);
        usersService.toggleImpersonation(userID, checked, handleSuccess, genericErrorToast);
    };

    return (
        <PasslyCheckbox
            name='supportJitCheckbox'
            checked={checked}
            onChange={handleCheck}
            label={translation('JIT_USER_ENABLE')}
            disabled={!hasOrgPermission([ManageAccount])}
        />
    );
};
